import { render, staticRenderFns } from "./integralSetUp.vue?vue&type=template&id=7fc38426&scoped=true&"
import script from "./integralSetUp.vue?vue&type=script&lang=js&"
export * from "./integralSetUp.vue?vue&type=script&lang=js&"
import style0 from "./integralSetUp.vue?vue&type=style&index=0&id=7fc38426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc38426",
  null
  
)

export default component.exports